import MaxAvatar from '../Assets/People/Max.jpg';
import KetlyAvatar from '../Assets/People/Ketly.jpg';
import AYAvatar from '../Assets/People/AY.jpg';

const RecommendationsList = [{
		id: 'rec-2',
		name: 'Ketly Freirik-Ralja',
		title: 'Co-Founder, CEO - Dottyland. Ex Inbank.',
		photo: KetlyAvatar,
		recommendation: `I've worked with Emmanuel on a blockchain project where he was leading the front-end development. He is very reliable, systematic and organised which combined with his engineering skills is making him a great developer.`
	},
	{
		id: 'rec-3',
		name: 'Ayotunde Olojede',
		title: 'Brand Manager, Sirjhoe. Ex Matta, Space FM.',
		photo: AYAvatar,
		recommendation: 'Emmanuel is a true professional who is passionate about using his skills to create solutions to problems. He is the epitome of knowledge and is always willing to learn and help others around him to become better. It is always a delight being on the same team with him because he personifies true value.'
	},
	{
		id: 'rec-1',
		name: 'Max Lion',
		title: 'Owner and Architect, Future Creative. Ex Paypal, Meta, Google, Community Gaming.',
		photo: MaxAvatar,
		recommendation: `I had the pleasure of hiring Emmanuel to pick up planning and development on a new website and management of existing infrastructure for my Web3 Gaming startup MetaMoon near the end of 2022 .
I was immediately impressed by Emmanuel’s professionalism, and thorough approach to the work that he did. His communication, planning and documentation, transparency, and follow through are all top-tier. His ability to talk through technical concepts with me to ensure the design was exactly as I envisioned it made our meetings collaborative and our workflow was seamless. I had been used to seeing design docs and having reference visuals/mockups in Silicon Valley, but it was a first for me to see that level of organization from someone doing freelance work.
Both in and outside of work Emmanuel is a very intelligent young man, with large aspirations, and a methodical mind. He’s fantastic to work with and even better to converse with when you get the opportunity.
You would be hard pressed to find someone with the drive, talent, and sociability Emmanuel brings to the table, and it’s well worth investing your time and energy into doing business with him. I've recently launched a new game development business and have hired Emmanuel's services once again, and am hoping we continue to work together for a long time to come`
	},
];

export default RecommendationsList;